import { render, staticRenderFns } from "./LatestBlog.vue?vue&type=template&id=4b125bda"
import script from "./LatestBlog.vue?vue&type=script&lang=js"
export * from "./LatestBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports